import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3aa610a7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "height": "100%"
  }
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "box_right"
};
const _hoisted_5 = {
  class: "name_s"
};
const _hoisted_6 = {
  class: "name"
};
const _hoisted_7 = {
  class: "mesage"
};
const _hoisted_8 = {
  class: "item_s"
};
const _hoisted_9 = {
  class: "last_time"
};
const _hoisted_10 = {
  key: 0,
  class: "loading"
};
const _hoisted_11 = {
  key: 1,
  class: "no-more"
};
import userimg from "../../assets/users.png";
import { debounce } from "lodash";
import { getgroup_list, getgroup_list2 } from "@/service/modules/alllist";
import { ref, watch } from "vue";
import { Search } from "@element-plus/icons-vue";
import { useScrollLoad } from "@/hooks/useScrollLoad";
export default /*#__PURE__*/_defineComponent({
  __name: 'group-chat',
  props: {
    from: {
      type: String,
      required: true // 确保 from 是必需的
    },

    activeName: {
      type: Number
    },
    show_chat: {
      type: Boolean,
      default: false
    }
  },
  emits: ["set_actives2"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const get_message = item => {
      let messages = JSON.parse(item.last_content);
      if (item.last_msgtype == "text") {
        return messages.content;
      }
      if (item.last_msgtype == "emotion") {
        return "[表情]";
      }
      if (item.last_msgtype == "image") {
        return "[图片]";
      }
      if (item.last_msgtype == "voice") {
        return "[语音]";
      }
      if (item.last_msgtype == "weapp") {
        return "[小程序消息]";
      }
    };
    const search = ref("");
    const actives = ref("");
    // const loading = ref(false);
    // const chat_list = ref([]);
    const scrollContainer = ref(null);
    // 使用滚动加载 Hook
    const {
      list,
      loading,
      hasMore,
      reset,
      loadData
    } = useScrollLoad({
      pageSize: 20,
      requestData: props.show_chat ? getgroup_list2 : getgroup_list,
      searchParams: () => ({
        status: props.activeName == 3 ? 1 : 2,
        from: props.from || "",
        search: search.value
      }),
      autoLoad: props.show_chat || Boolean(props.from)
    });
    const handScroll = () => {
      if (!scrollContainer.value) return;
      // 获取滚动容器
      const container = scrollContainer.value;
      // 计算滚动位置
      const scrollTop = container.scrollTop; // 当前滚动距离
      const scrollHeight = container.scrollHeight; // 总高度
      const clientHeight = container.clientHeight; // 可视区高度
      if (scrollHeight - scrollTop - clientHeight <= 50) {
        loadData();
      }
    };
    watch(() => list.value, newValue => {
      if (newValue && newValue.length > 0) {
        get_select_one();
      } else {
        emit("set_actives2", {});
      }
    });
    const get_select_one = async () => {
      actives.value = list.value[0].chat_id;
      emit("set_actives2", list.value[0]);
    };
    // 监听 props.from 的变化
    watch(() => props.from, newValue => {
      reset();
    });
    // 监听 props.activeName 的变化
    watch(() => props.activeName, newValue => {
      reset();
    });
    // 搜索变化的防抖函数
    const changes = debounce(() => {
      reset();
    }, 300);
    const emit = __emit;
    const set_actives = item => {
      actives.value = item.chat_id;
      emit("set_actives2", item);
    };
    const get_lasttime = item => {
      if (!item.last_time) return;
      return item.last_time.slice(5, 10);
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_input, {
        modelValue: search.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => search.value = $event),
        class: "seach",
        placeholder: "搜索群名称",
        "prefix-icon": _unref(Search),
        onInput: _unref(changes)
      }, null, 8, ["modelValue", "prefix-icon", "onInput"]), _createElementVNode("div", {
        class: "user_s_1",
        ref_key: "scrollContainer",
        ref: scrollContainer,
        onScroll: handScroll
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["item-box", actives.value == item.chat_id ? 'item-box-bg' : '']),
          onClick: $event => set_actives(item)
        }, [_createElementVNode("img", {
          class: "ac_img",
          src: _unref(userimg),
          alt: ""
        }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(item.name), 1)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(get_message(item)), 1), _createElementVNode("span", _hoisted_9, _toDisplayString(get_lasttime(item)), 1)])])], 10, _hoisted_2);
      }), 128)), _unref(loading) ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [_createTextVNode("加载中...")])), [[_directive_loading, _unref(loading)]]) : _createCommentVNode("", true), !_unref(hasMore) && _unref(list).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 没有更多数据了 ")) : _createCommentVNode("", true)], 544)]);
    };
  }
});